import React from 'react';

import {
  Skeleton,
  SkeletonCircle,
  SkeletonText,
  Stack,
} from '@chakra-ui/react';

import style from './styles/DashboardHomeSkeleton.style';

const DashboardHomeSkeleton = () => {
  return (
    <Stack sx={style.root}>
      <SkeletonText
        className="dashboardHomeSkeletonText1"
        skeletonHeight={'4'}
      />

      <Stack className="dashboardHomeSkeletonStack1">
        <Stack className="dashboardHomeSkeletonStack2">
          <SkeletonText
            skeletonHeight={'3'}
            className="dashboardHomeSkeletonText3"
          />
          <SkeletonText
            className="dashboardHomeSkeletonText4"
            skeletonHeight={'3'}
          />
        </Stack>
      </Stack>
      <Stack className="dashboardHomeSkeletonStack3">
        <Skeleton className="dashboardHomeSkeleton" />
        <Stack className="dashboardHomeSkeletonStack4">
          <SkeletonText
            className="dashboardHomeSkeletonText5"
            skeletonHeight={'5'}
          />
          <SkeletonText
            className="dashboardHomeSkeletonText6"
            skeletonHeight={'2'}
          />
          <SkeletonCircle className="dashboardHomeSkeletonCircle" />
        </Stack>
      </Stack>
      {/* <Stack mt="5px">
        <SkeletonText
          className="dashboardHomeSkeletonText"
          skeletonHeight={'5'}
        />
        <SkeletonText
          className="dashboardHomeSkeletonText2"
          skeletonHeight={'5'}
        />
        <SkeletonText
          className="dashboardHomeSkeletonText2"
          skeletonHeight={'5'}
        />
      </Stack> */}
    </Stack>
  );
};

export default DashboardHomeSkeleton;
